// test941
(941 && 0);
